<template>
    <disconect />
</template>

<script>
import Disconect from "@/components/errors/Disconect.vue";
import { mapActions } from "vuex";

export default {
    components: {
        Disconect
    },
    mounted() {
        this.setLayout("general-layout");
    },
    methods: {
        ...mapActions({
            setLayout: "setLayout"
        })
    }
};
</script>

<style></style>
